import { Box, SxProps, Theme } from '@mui/material';
import insightLogo from 'assets/insight-logo.png';

const rootStyles: SxProps<Theme> = {
  maxHeight: theme => theme.mixins.toolbar.minHeight,
};
export function Logo() {
  return <Box component='img' sx={rootStyles} src={insightLogo} alt='insight logo' />;
}
